export * from './incidentText';